const ellipsis = value => {
    if (!value) return '';
    if (value.length > 10) {
        return value.slice(0, 10) + '...';
    }
    return value;
};
const ellipsis13 = value => {
    if (!value) return '';
    if (value.length > 13) {
        return value.slice(0, 13) + '...';
    }
    return value;
};
const ellipsis15 = value => {
  if (!value) return '';
  if (value.length > 15) {
      return value.slice(0, 15) + '...';
  }
  return value;
};
const ellipsis18 = value => {
    if (!value) return '';
    if (value.length > 18) {
        return value.slice(0, 18) + '...';
    }
    return value;
};
const ellipsis20 = value => {
    if (!value) return '';
    if (value.length > 20) {
        return value.slice(0, 20) + '...';
    }
    return value;
};
const ellipsis30 = value => {
    if (!value) return '';
    if (value.length > 30) {
        return value.slice(0, 30) + '...';
    }
    return value;
};
const ellipsis50 = value => {
    if (!value) return '';
    if (value.length > 50) {
        return value.slice(0, 50) + '...';
    }
    return value;
};
const ellipsis100 = value => {
    if (!value) return '';
    if (value.length > 100) {
        return value.slice(0, 100) + '...';
    }
    return value;
};
export { ellipsis, ellipsis13, ellipsis15, ellipsis18, ellipsis20, ellipsis30, ellipsis50, ellipsis100 };
